//时间 开始日期不晚于当前时间和结束时间
//srTime  结束时间
export const startTime = (srTime) => {
  return {
    disabledDate: (time) => {
      if (srTime) {
        return time.getTime() > new Date(srTime).getTime() || time.getTime() > Date.now();
      } else {
        return time.getTime() > Date.now();
      }
    },
  };
};
//结束日期不早于开始日期
//起始时间
export const endTime = (srTime) => {
  return {
    disabledDate: (time) => {
      if (srTime) {
        return time.getTime() < new Date(srTime).getTime();
      }
    },
    shortcuts: [{
        text: "今天",
        onClick(picker) {
          picker.$emit("pick", new Date());
        },
      },
      {
        text: "永久日期",
        onClick(picker) {
          const date = new Date("2099-12-31");
          picker.$emit("pick", date);
        },
      },
    ],
  };
};
//数量校验
//zhengshuwei整数位, xiaoshuwei小数位, type必填，选填
export const validateSljy = (rule, value, callback, zhengshuwei, xiaoshuwei, type) => {
  if (value === "" && type == "bt")
    callback(new Error("请输入"));
  else if (value < 0)
    callback(new Error("请输入正数"));
  else if (
    !/(^[0-9]([0-9]+)?(\.[0-9]{1,3})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(
      value
    ) && value !== ""
  )
    callback(new Error("最多输入" + xiaoshuwei + "位小数"));
  else if (
    !/^[1-9]\d{0,9}(\.\d{1,3})?$|^0(\.\d{1,3})?$/.test(
      value) && value !== ""
  )
    callback(new Error("最多输入" + zhengshuwei + "个整数位"));
  callback();
}
//表单验证填写（必填项不能为空）
export const validateNull = (rule, value, callback) => {
  if (value === "") return callback(new Error('必填项不能为空！'));
  else if (value == null) return callback(new Error('必填项不能为空！'));
  else if (!value.toString().trim()) return callback(new Error('必填项不能为空！'));
  callback();
};
//单位座机
export const validatezj = (rule, value, callback) => {
  // const reg1 = /^(0\d{2,3}-\d{7,8})$/; // 座机
  // const reg2 = /^1[3456789]\d{9}$/;
  // if (!reg1.test(value) && !reg2.test(value)) {
  //     callback(new Error("请输入正确的电话或手机号格式"));
  // }
  var reg3 = /^[\+\-]?\d*?\-?\d*?$/; //数字和-
  if (!value.trim()) {
    return callback(new Error('必填项不能为空！'));
  }
  if (!reg3.test(value)) {
    callback(new Error("请输入正确的电话或手机号格式"));
  }
  callback();
};
//表单中输入手机号验证
//type必填，选填
export const validateMobile = (rule, value, callback, type) => {
  const mobile = /^1[3456789]\d{9}$/;
  if (!value && type == "bt") {
    return callback(new Error('手机号不能为空！'));
  }
  if (!mobile.test(value) && value != "") {
    return callback(new Error('手机号格式错误！'));
  }
  callback()
}

//长度校验  type 必填   length 长度
export const lengthValidate = (rule, value, callback, type, length) => {

  if (!value && type == "bt") {
    return callback(new Error('必填项不能为空！'));
  }
  if (value && value.length > length) {
    return callback(new Error('输入字符为1到' + length + '之间！'));
  }
  callback()
}


//表单中身份证
export const validateIdentityCode = (rule, code, callback) => {
  //验证身份证合法性
  var city = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江 ",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北 ",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏 ",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外 ",
  };
  var patt1 = new RegExp(
    "(^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{2}$)"
  );
  if (!code) return callback(new Error('身份证号不可为空'));
  if (!patt1.test(code)) {
    return callback(new Error('身份证号格式错误'));
  } else if (!city[code.substr(0, 2)]) {
    return callback(new Error('地址编码错误'));
  } else {
    //18位身份证需要验证最后一位校验位
    if (code.length == 18) {
      code = code.split("");
      //∑(ai×Wi)(mod 11)
      //加权因子
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      //校验位
      var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
      var sum = 0;
      var ai = 0;
      var wi = 0;
      for (var i = 0; i < 17; i++) {
        ai = code[i];
        wi = factor[i];
        sum += ai * wi;
      }
      if (parity[sum % 11] != code[17]) {
        return callback(new Error('校验位错误'));
      }
    }
  }
  callback()
}
